import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { VStack } from "@design-system/VStack/VStack";
import animations from "../../layout/OnboardingLayout.module.scss";
import commonStyles from "../common.module.scss";

export const AccountantPartnerCallOutro: React.FC = () => (
    <div className={classNames(commonStyles.content420, animations.fadeIn1)}>
        <header className={animations.fadeIn2}>
            <h1 className={commonStyles.title}>Get ready for your Kick demo</h1>
        </header>

        <div className={animations.fadeIn1}>
            <div className="mb-3">Ahead of the demo:</div>
            <div>1. Confirm it’s in your calendar</div>
            <div>2. Collect bank statements so you can see Kick in action</div>
            <div>3. Prepare to share what’s next for your firm</div>
        </div>

        <VStack as="footer" align="start" className="mt-4">
            <Button
                asChild
                variant="primary"
                className={animations.fadeIn1}
                size="xl"
            >
                <a
                    href="https://x.com/kickfinance"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Follow us on X
                </a>
            </Button>
        </VStack>
    </div>
);
